import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import { EventService } from '../../../services/EventService';
import LoginServices from '../../../services/LoginServices';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { UserService } from '../../../services/UserService';
import { UserRole } from '../../../types/UserRole';
/**
 * interface State (le parametre de la classe)
 */
interface State {
    frais?: ReqType.Frais[];
    newFrais: {
        intutule: string,
        montant: string,
    };
    users: ReqType.UserView[];
}

interface Props {
    event: ReqType.Event;
}
/**
 * Ce composant affiche une Liste Frais Event.
 * Elle prend en paramétres un event et fais appel aux services EventService pour obtenir les frais
 * associer à chaque événement et pour supprimer des frais, UserService pour obtenir la liste des utilisateurs et
 * LoginService pour obtenir des identifiants d'utilisateur.
 */
export class ListFraisEvent extends React.Component {
    state: State;
    props: Props;

    /**
     * le constructeur de la classe ListFraisEvent
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            users: [],
            newFrais: {
                intutule: '',
                montant: '0.0',
            }
        };

        const userRole = LoginServices.getInstance().getType();

        if (userRole === UserRole.ADMIN.toString()) {
            EventService.getInstance().getEventFees(this.props.event.id).then(
                (fees: ReqType.Frais[]) => {
                    this.setState({ frais: fees });
                }
            );
        } else {
            const userId = LoginServices.getInstance().getUserId();
            if (userId !== undefined) {
                UserService.getInstance().getUserFees(userId).then(
                    (fees: ReqType.Frais[]) => {
                        var filtered = fees.filter(
                            (fee: ReqType.Frais) => {
                                return (fee.event_id === this.props.event.id);
                            }
                        );
                        this.setState({ frais: filtered });
                    }
                );
            }
        }

        if (userRole === UserRole.ADMIN.toString()) {
            UserService.getInstance().getUsers().then(
                (users: ReqType.UserView[]) => {
                    var arr: ReqType.UserView[] = [];
                    users.map(
                        (user: ReqType.UserView) => {
                            arr[user.id] = user;
                        }
                    );
                    this.setState({ users: arr });
                }
            );
        } else {
            const userId = LoginServices.getInstance().getUserId();
            if (userId !== undefined) {
                UserService.getInstance().getUser(userId).then(
                    (user: ReqType.UserView) => {
                        var arr: ReqType.UserView[] = [];
                        arr[user.id] = user;
                        this.setState({ users: arr });
                    }
                );
            }
        }
    }

    /**
     * le rendu de la classe ListFraisEvent
     * @returns {JSX.element}
     */
    render() {
        var listItems: JSX.Element[] | undefined;
        if (this.state.frais !== undefined) {
            listItems = this.state.frais.map(this.ligneFrais);
        }

        return (
            <div className="card card-default" >
                <div className="card-header col-12">
                    <h4 className="text-white">
                        <strong> Frais </strong>
                    </h4>
                </div>
                <div className="card-body col-12"  style={{overflow: 'auto', maxHeight: '400px'}}>
                    <TableChorinitia
                        header={
                            <thead className="thead-light">
                                <tr>
                                    <th scope="col">Intitulé</th>
                                    <th scope="col">Montant</th>
                                    <th scope="col">Membre</th>
                                    <th scope="col" />
                                </tr>
                            </thead>
                        }
                    >
                        <tbody>
                            {this.displayFormFrais()}
                            {listItems}
                        </tbody>
                    </TableChorinitia>
                </div>
            </div>
        );
    }

    /**
     * affichage du formulaire de frais
     * @returns {JSX.Element}
     */
    private displayFormFrais(): JSX.Element {
        var user: ReqType.UserView | undefined;
        if (this.state.users !== undefined) {
            user = this.state.users[LoginServices.getInstance().getUserId()!];
        }

        return (
            <tr>
                <td>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Intitulé"
                        value={this.state.newFrais.intutule}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newFrais = this.state.newFrais;
                                newFrais.intutule = e.target.value;
                                this.setState({ newFrais: newFrais });
                            }
                        }
                    />
                </td>
                <td>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Montant"
                        value={this.state.newFrais.montant}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newFrais = this.state.newFrais;
                                newFrais.montant = e.target.value;
                                this.setState({ newFrais: newFrais });
                            }
                        }
                    />
                </td>
                <td>
                    <strong>
                        {user === undefined || user.userProfile === null ? '' : user.userProfile.nom + ' '}
                    </strong>
                    {user === undefined || user.userProfile === null ? '' : user.userProfile.prenom}
                </td>
                <td>
                    <LoaderButton
                        className={'btn badge-success ' + (this.state.newFrais.intutule === '' ? 'disabled' : '')}
                        onClick={
                            () => {
                                if (this.state.newFrais.intutule === '') {
                                    return Promise.reject('');
                                }
                                const monFrais: ReqType.Frais = {
                                    event_id: this.props.event.id,
                                    id: this.state.frais === undefined ? 1 : this.state.frais.length + 1,
                                    intitule: this.state.newFrais.intutule,
                                    montant: this.state.newFrais.montant,
                                    user_id: LoginServices.getInstance().getUserId()!,
                                };
                                return (EventService.getInstance().addEventFee(monFrais).then(
                                    () => {
                                        var frais = this.state.frais;
                                        if (frais === undefined) {
                                            frais = [];
                                        }
                                        frais.push(monFrais);
                                        this.setState(
                                            {
                                                frais: frais,
                                                newFrais: {
                                                    intutule: '',
                                                    montant: 0.0,
                                                }
                                            }
                                        );
                                    }
                                ));
                            }
                        }
                    >
                        <i className="fas fa-plus" />
                    </LoaderButton>
                </td>
            </tr>
        );
    }

    /**
     * correspond à une ligne dans le tableau des Frais
     * @param {Frais} frais
     * @param {number} index
     * @returns {JSX.Element}
     */
    private ligneFrais = (frais: ReqType.Frais, index: number) => {
        var user: ReqType.UserView | undefined = this.state.users[frais.user_id];

        return (
            <tr key={index}>
                <td>{frais.intitule}</td>
                <td>{frais.montant}</td>
                <td>
                    <strong>
                        {user === undefined || user.userProfile === null ? '' : user.userProfile!.nom + ' '}
                    </strong>
                    {user === undefined || user.userProfile === null ? '' : user.userProfile!.prenom}
                </td>
                <td>
                    <LoaderButton
                        className="btn badge-danger"
                        onClick={
                            () => {
                                return (
                                    EventService.getInstance().deleteEventFee(frais).then(
                                        () => {
                                            var lesFrais = this.state.frais;
                                            if (lesFrais === undefined) {
                                                lesFrais = [];
                                            } else {
                                                lesFrais.splice(index, 1);
                                            }
                                            this.setState(
                                                {
                                                    frais: lesFrais
                                                }
                                            );
                                        }
                                    )
                                );
                            }
                        }
                    >
                        <i className="fas fa-minus" />
                    </LoaderButton>
                </td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/EventPage/internalComponents/ListFraisEvent.tsx